import { render, staticRenderFns } from "./TimeTag.vue?vue&type=template&id=37c22a40&lang=pug"
import script from "./TimeTag.vue?vue&type=script&lang=js"
export * from "./TimeTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports